import { FC } from "react";

import { serverClearVotes } from "api/api-server-actions";
import { t } from "i18n/i18n";
import { CloseButton } from "mds/components/CloseButton";
import { IconText } from "mds/components/IconText";
import { ReactionVoteNoIcon, ReactionVoteYesIcon } from "mds/icons";
import { cn } from "mds/utils/cn";
import { useCapabilities } from "store/capability-hooks";
import { useAppSelector } from "store/index";
import {
  selectActiveClassSessionId,
  selectCurrentClassUser,
  selectCurrentClassUserList,
} from "store/selectors";
import { useListSelector } from "store/store-hooks";

const VoteRollup: FC = () => {
  const classSessionId = useAppSelector(selectActiveClassSessionId);
  const classUsers = useListSelector(selectCurrentClassUserList, ["vote"]);
  const currentClassUser = useAppSelector(selectCurrentClassUser);
  const { canAuthorCourse, canParticipateInCourse } = useCapabilities();

  const [yesCount, noCount] = classUsers.reduce(
    ([yesSum, noSum], classUser) => {
      return [
        yesSum + (classUser.vote === "yes" ? 1 : 0),
        noSum + (classUser.vote === "no" ? 1 : 0),
      ];
    },
    [0, 0] as [number, number],
  );

  if ((yesCount === 0 && noCount === 0) || (canParticipateInCourse && !currentClassUser?.vote)) {
    return null;
  }

  return (
    <div className="flex gap-0.5">
      <div
        className={cn(
          "flex items-center gap-3 rounded-lg bg-black-tint-97 px-3 py-1 group-data-[dark]/themable:bg-black-tint-20",
          canAuthorCourse && "rounded-r-none",
        )}
      >
        <span>{t("reactions.votes")}:</span>
        <IconText iconStart={<ReactionVoteNoIcon />} text={noCount} />
        <IconText iconStart={<ReactionVoteYesIcon />} text={yesCount} />
      </div>
      {canAuthorCourse && (
        <CloseButton
          className="rounded-l-none"
          kind="squareLegacy"
          size="s"
          title={t("reactions.clear_votes")}
          onClick={() => {
            serverClearVotes(classSessionId);
          }}
        />
      )}
    </div>
  );
};

export { VoteRollup };
